import * as React from 'react'
import { State } from '../../store'
import { useDispatch, useSelector } from 'react-redux'
import Modal from 'antd/lib/modal/Modal'
import { Spin, Steps } from 'antd'
import { FormattedMessage } from 'react-intl'
import Import from './Import'
import SelectSheets from './SelectSheets'
import AssignColumns from './AssignColumns'
import ConfirmUpload from './ConfirmUpload'
import styled from 'styled-components'
import { cancelUploadAction } from './types'
import { flow } from 'fp-ts/lib/function'

const stateToStep = (st: State['upload']['state']): number => {
  switch (st) {
    case 'Open':
      return 0
    case 'Select':
      return 1
    case 'Assign':
      return 2
    default:
      return 3
  }
}

const MarginSteps = styled(Steps)`
  margin: 24px 0;
`

const SizedModal = styled(Modal)`
  max-width: 800px;
  width: 75%;
`

const stepComponent = {
  Open: <Import />,
  Select: <SelectSheets key="select" />,
  Assign: <AssignColumns key="assign" />,
  Confirm: <ConfirmUpload key="confirm" />,
  Loading: <Spin spinning={true} />,
  Closed: null,
  Error: null,
}

const Upload = () => {
  const state = useSelector(s => s.upload.state)
  const dispatch = useDispatch()

  return (
    <SizedModal
      visible={state !== 'Closed'}
      confirmLoading={state === 'Loading'}
      footer={null}
      width=""
      onCancel={flow(cancelUploadAction, dispatch)}
    >
      <Spin spinning={state === 'Loading'}>
        {state === 'Error' ? (
          <div>TODO: error stuff </div>
        ) : (
          <>
            <MarginSteps current={stateToStep(state)}>
              <Steps.Step title={<FormattedMessage id="importExcel" />} />
              <Steps.Step title={<FormattedMessage id="selectSheets" />} />
              <Steps.Step title={<FormattedMessage id="assignColumns" />} />
              <Steps.Step title={<FormattedMessage id="confirm" />} />
            </MarginSteps>
            {stepComponent[state]}
          </>
        )}
      </Spin>
    </SizedModal>
  )
}

export default Upload
